module.exports = __webpack_public_path__ + "bed6fcf9881455cc030805d2800eac0a.svg";